import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PaisesEsocialService {
  private paises: { label: string; value: string }[] = [
    { label: 'Afeganistão', value: '013' },
    { label: 'Albânia, República da', value: '017' },
    { label: 'Alemanha', value: '023' },
    { label: 'Burkina Faso', value: '031' },
    { label: 'Andorra', value: '037' },
    { label: 'Angola', value: '040' },
    { label: 'Anguilla', value: '041' },
    { label: 'Antígua e Barbuda', value: '043' },
    { label: 'Arábia Saudita', value: '053' },
    { label: 'Argélia', value: '059' },
    { label: 'Argentina', value: '063' },
    { label: 'Armênia, República da', value: '064' },
    { label: 'Aruba', value: '065' },
    { label: 'Austrália', value: '069' },
    { label: 'Áustria', value: '072' },
    { label: 'Azerbaijão, República do', value: '073' },
    { label: 'Bahamas, Ilhas', value: '077' },
    { label: 'Bahrein, Ilhas', value: '080' },
    { label: 'Bangladesh', value: '081' },
    { label: 'Barbados', value: '083' },
    { label: 'Belarus, República da', value: '085' },
    { label: 'Bélgica', value: '087' },
    { label: 'Belize', value: '088' },
    { label: 'Bermudas', value: '090' },
    { label: 'Mianmar (Birmânia)', value: '093' },
    { label: 'Bolívia, Estado Plurinacional da', value: '097' },
    { label: 'Bósnia-Herzegovina, República da', value: '098' },
    { label: 'Bonaire, Saint Eustatius e Saba', value: '099' },
    { label: 'Botsuana', value: '101' },
    { label: 'Bouvet, Ilha', value: '102' },
    { label: 'Brasil', value: '105' },
    { label: 'Brunei', value: '108' },
    { label: 'Bulgária, República da', value: '111' },
    { label: 'Burundi', value: '115' },
    { label: 'Butão', value: '119' },
    { label: 'Cabo Verde, República de', value: '127' },
    { label: 'Cayman, Ilhas', value: '137' },
    { label: 'Camboja', value: '141' },
    { label: 'Camarões', value: '145' },
    { label: 'Canadá', value: '149' },
    { label: 'Cazaquistão, República do', value: '153' },
    { label: 'Catar', value: '154' },
    { label: 'Chile', value: '158' },
    { label: 'China, República Popular da', value: '160' },
    { label: 'Formosa (Taiwan)', value: '161' },
    { label: 'Chipre', value: '163' },
    { label: 'Cocos (Keeling), Ilhas', value: '165' },
    { label: 'Colômbia', value: '169' },
    { label: 'Comores, Ilhas', value: '173' },
    { label: 'Congo', value: '177' },
    { label: 'Cook, Ilhas', value: '183' },
    { label: 'Coreia (do Norte), República Popular Democrática da', value: '187' },
    { label: 'Coreia (do Sul), República da', value: '190' },
    { label: 'Costa do Marfim', value: '193' },
    { label: 'Croácia, República da', value: '195' },
    { label: 'Costa Rica', value: '196' },
    { label: 'Kuwait', value: '198' },
    { label: 'Cuba', value: '199' },
    { label: 'Curaçao', value: '200' },
    { label: 'Benim', value: '229' },
    { label: 'Dinamarca', value: '232' },
    { label: 'Dominica, Ilha', value: '235' },
    { label: 'Equador', value: '239' },
    { label: 'Egito', value: '240' },
    { label: 'Eritreia', value: '243' },
    { label: 'Emirados Árabes Unidos', value: '244' },
    { label: 'Espanha', value: '245' },
    { label: 'Eslovênia, República da', value: '246' },
    { label: 'Eslovaca, República', value: '247' },
    { label: 'Estados Unidos', value: '249' },
    { label: 'Estônia, República da', value: '251' },
    { label: 'Etiópia', value: '253' },
    { label: 'Falkland (Ilhas Malvinas)', value: '255' },
    { label: 'Feroe, Ilhas', value: '259' },
    { label: 'Filipinas', value: '267' },
    { label: 'Finlândia', value: '271' },
    { label: 'França', value: '275' },
    { label: 'Gabão', value: '281' },
    { label: 'Gâmbia', value: '285' },
    { label: 'Gana', value: '289' },
    { label: 'Geórgia, República da', value: '291' },
    { label: 'Gibraltar', value: '293' },
    { label: 'Granada', value: '297' },
    { label: 'Grécia', value: '301' },
    { label: 'Groenlândia', value: '305' },
    { label: 'Guadalupe', value: '309' },
    { label: 'Guam', value: '313' },
    { label: 'Guatemala', value: '317' },
    { label: 'Guernsey, Ilha do Canal', value: '321' },
    { label: 'Guiana Francesa', value: '325' },
    { label: 'Guiné', value: '329' },
    { label: 'Guiné Equatorial', value: '331' },
    { label: 'Guiné-Bissau', value: '334' },
    { label: 'Guiana', value: '337' },
    { label: 'Haiti', value: '341' },
    { label: 'Honduras', value: '345' },
    { label: 'Hong Kong', value: '351' },
    { label: 'Hungria, República da', value: '355' },
    { label: 'Iêmen', value: '357' },
    { label: 'Man, Ilha de', value: '359' },
    { label: 'Índia', value: '361' },
    { label: 'Indonésia', value: '365' },
    { label: 'Iraque', value: '369' },
    { label: 'Irã, República Islâmica do', value: '372' },
    { label: 'Irlanda', value: '375' },
    { label: 'Islândia', value: '379' },
    { label: 'Israel', value: '383' },
    { label: 'Itália', value: '386' },
    { label: 'Jamaica', value: '391' },
    { label: 'Jersey, Ilha do Canal', value: '393' },
    { label: 'Japão', value: '399' },
    { label: 'Jordânia', value: '403' },
    { label: 'Kiribati', value: '411' },
    { label: 'Laos, República Popular Democrática do', value: '420' },
    { label: 'Lesoto', value: '426' },
    { label: 'Letônia, República da', value: '427' },
    { label: 'Líbano', value: '431' },
    { label: 'Libéria', value: '434' },
    { label: 'Líbia', value: '438' },
    { label: 'Liechtenstein', value: '440' },
    { label: 'Lituânia, República da', value: '442' },
    { label: 'Luxemburgo', value: '445' },
    { label: 'Macau', value: '447' },
    { label: 'Macedônia do Norte', value: '449' },
    { label: 'Madagascar', value: '450' },
    { label: 'Malásia', value: '455' },
    { label: 'Malavi', value: '458' },
    { label: 'Maldivas', value: '461' },
    { label: 'Mali', value: '464' },
    { label: 'Malta', value: '467' },
    { label: 'Marianas do Norte', value: '472' },
    { label: 'Marrocos', value: '474' },
    { label: 'Marshall, Ilhas', value: '476' },
    { label: 'Martinica', value: '477' },
    { label: 'Maurício', value: '485' },
    { label: 'Mauritânia', value: '488' },
    { label: 'México', value: '493' },
    { label: 'Moldávia, República da', value: '494' },
    { label: 'Mônaco', value: '495' },
    { label: 'Mongólia', value: '497' },
    { label: 'Montenegro', value: '498' },
    { label: 'Micronésia', value: '499' },
    { label: 'Montserrat, Ilhas', value: '501' },
    { label: 'Moçambique', value: '505' },
    { label: 'Namíbia', value: '507' },
    { label: 'Nauru', value: '508' },
    { label: 'Christmas, Ilha (Navidad)', value: '511' },
    { label: 'Nepal', value: '517' },
    { label: 'Nicarágua', value: '521' },
    { label: 'Níger', value: '525' },
    { label: 'Nigéria', value: '528' },
    { label: 'Niue, Ilha', value: '531' },
    { label: 'Norfolk, Ilha', value: '535' },
    { label: 'Noruega', value: '538' },
    { label: 'Nova Caledônia', value: '542' },
    { label: 'Papua Nova Guiné', value: '545' },
    { label: 'Nova Zelândia', value: '548' },
    { label: 'Vanuatu', value: '551' },
    { label: 'Omã', value: '556' },
    { label: 'Pacífico, Ilhas do (Possessão dos EUA)', value: '566' },
    { label: 'Países Baixos (Holanda)', value: '573' },
    { label: 'Palau', value: '575' },
    { label: 'Paquistão', value: '576' },
    { label: 'Palestina', value: '578' },
    { label: 'Panamá', value: '580' },
    { label: 'Paraguai', value: '586' },
    { label: 'Peru', value: '589' },
    { label: 'Pitcairn, Ilha', value: '593' },
    { label: 'Polinésia Francesa', value: '599' },
    { label: 'Polônia, República da', value: '603' },
    { label: 'Portugal', value: '607' },
    { label: 'Porto Rico', value: '611' },
    { label: 'Quênia', value: '623' },
    { label: 'Quirguiz, República', value: '625' },
    { label: 'Reino Unido', value: '628' },
    { label: 'República Centro-Africana', value: '640' },
    { label: 'República Dominicana', value: '647' },
    { label: 'Reunião, Ilha', value: '660' },
    { label: 'Zimbábue', value: '665' },
    { label: 'Romênia', value: '670' },
    { label: 'Ruanda', value: '675' },
    { label: 'Rússia, Federação da', value: '676' },
    { label: 'Salomão, Ilhas', value: '677' },
    { label: 'Saara Ocidental', value: '685' },
    { label: 'El Salvador', value: '687' },
    { label: 'Samoa', value: '690' },
    { label: 'Samoa Americana', value: '691' },
    { label: 'São Cristóvão e Neves, Ilhas', value: '695' },
    { label: 'San Marino', value: '697' },
    { label: 'São Martinho, Ilha de (Parte Francesa)', value: '698' },
    { label: 'São Martinho, Ilha de (Parte Holandesa)', value: '699' },
    { label: 'São Pedro e Miquelon', value: '700' },
    { label: 'São Vicente e Granadinas', value: '705' },
    { label: 'Santa Helena', value: '710' },
    { label: 'Santa Lúcia', value: '715' },
    { label: 'São Tomé e Príncipe, Ilhas', value: '720' },
    { label: 'Senegal', value: '728' },
    { label: 'Seychelles', value: '731' },
    { label: 'Serra Leoa', value: '735' },
    { label: 'Sérvia', value: '737' },
    { label: 'Singapura', value: '741' },
    { label: 'Síria, República Árabe da', value: '744' },
    { label: 'Somália', value: '748' },
    { label: 'Sri Lanka', value: '750' },
    { label: 'eSwatini (Essuatíni, Suazilândia)', value: '754' },
    { label: 'Svalbard e Jan Mayen', value: '755' },
    { label: 'África do Sul', value: '756' },
    { label: 'Sudão', value: '759' },
    { label: 'Sudão do Sul', value: '760' },
    { label: 'Suécia', value: '764' },
    { label: 'Suíça', value: '767' },
    { label: 'Suriname', value: '770' },
    { label: 'Tadjiquistão, República do', value: '772' },
    { label: 'Tailândia', value: '776' },
    { label: 'Tanzânia, República Unida da', value: '780' },
    { label: 'Território Britânico Oceano Índico', value: '782' },
    { label: 'Djibuti', value: '783' },
    { label: 'Chade', value: '788' },
    { label: 'Tcheca, República', value: '791' },
    { label: 'Timor Leste', value: '795' },
    { label: 'Togo', value: '800' },
    { label: 'Toquelau, Ilhas', value: '805' },
    { label: 'Tonga', value: '810' },
    { label: 'Trinidad e Tobago', value: '815' },
    { label: 'Tunísia', value: '820' },
    { label: 'Turcas e Caicos, Ilhas', value: '823' },
    { label: 'Turcomenistão, República do', value: '824' },
    { label: 'Turquia', value: '827' },
    { label: 'Tuvalu', value: '828' },
    { label: 'Ucrânia', value: '831' },
    { label: 'Uganda', value: '833' },
    { label: 'Uruguai', value: '845' },
    { label: 'Uzbequistão, República do', value: '847' },
    { label: 'Vaticano, Estado da Cidade do', value: '848' },
    { label: 'Venezuela', value: '850' },
    { label: 'Vietnã', value: '858' },
    { label: 'Virgens, Ilhas (Britânicas)', value: '863' },
    { label: 'Virgens, Ilhas (EUA)', value: '866' },
    { label: 'Fiji', value: '870' },
    { label: 'Wallis e Futuna, Ilhas', value: '875' },
    { label: 'Congo, República Democrática do', value: '888' },
    { label: 'Zâmbia', value: '890' },
    { label: 'Bancos Centrais', value: '995' },
    { label: 'Organizações Internacionais', value: '997' }
  ];

  getPaises(): { label: string; value: string }[] {
    return this.paises;
  }
}
